<template>
    <div>
        <top-carousel></top-carousel>
        <div class="container culture-content">
            <img src="../../../../assets/img/culture/cal.jpg" alt=""  class="img-responsive"/>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style scoped lang="less">
.culture-content{
    padding:60px 0;
    img{
        margin:0 auto;
    }
}
</style>
